export default __webpack_public_path__ + "static/media/usdt.0888a147.svg";